import {FaStar} from 'react-icons/fa';
import { FaRegStar, FaRegStarHalfStroke}  from 'react-icons/fa6';
const starCreator = (num) =>{
    return Array.from({length: 5}, (_, index)=>{
        if(num >= index+1){
            return  <FaStar key={index} className='star' fill='#fca903'/>;
        }
        else if(num >= index+0){
            return <FaRegStarHalfStroke key={index} className='star' fill='#fca903'/>
        }
        else{
            return  <FaRegStar key={index} className='star' fill='#fca903'/>
        }
    });
}

export default starCreator;